import React from "react";

export interface IIconChevronRight {}

export default function IconChevronRight() {
  return (
    <svg
      className="w-full h-full stroke-brij-Grey"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
    </svg>
  );
}
